import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { LocalStorage } from 'ts-localstorage'
import { Dropdown, MenuProps, Space } from 'antd'
import Icon from '../UI/Icons/Icons'
import { useAppSelector } from '../../hooks/appHook'
import { LogoutOutlined, ProfileOutlined, TeamOutlined } from '@ant-design/icons'
import './accountMenu.less'
import { ADMIN_ACCOUNT_ID, ADMIN_USER_ID } from '../../config/consts'
import { useTranslation } from 'react-i18next'
import { resetAgentsSlice } from '../../store/slices/agents.slice'
import { useDispatch } from 'react-redux'

const AccountMenu = () => {
  const { t } = useTranslation('components')
  const { user } = useAppSelector((state) => state.appState)
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const logout = () => {
    const adminUserId = LocalStorage.getItem(ADMIN_USER_ID)
    const adminAccountId = LocalStorage.getItem(ADMIN_ACCOUNT_ID)

    if (adminAccountId || adminUserId) {
      LocalStorage.removeItem(ADMIN_USER_ID)
      LocalStorage.removeItem(ADMIN_ACCOUNT_ID)
      dispatch(resetAgentsSlice())
    } else {
      LocalStorage.clear()
    }
    navigate('/signin')
    window.location.reload()
  }

  const items: MenuProps['items'] = [
    {
      label: (
        <div>
          <div className="account-menu-username">{user.name}</div>
          <div className="account-menu-email">{user.email}</div>
        </div>
      ),
      key: 'User',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <Link to="profile">
          <Space>
            <ProfileOutlined />
            {t('accountMenu.myProfile')}
          </Space>
        </Link>
      ),
      key: 'MyProfile',
    },
    {
      label: (
        <Link to="team">
          <Space>
            <TeamOutlined />
            {t('accountMenu.team')}
          </Space>
        </Link>
      ),
      key: 'Team',
    },
    {
      type: 'divider',
    },
    {
      label: (
        <div data-testid="logout" onClick={() => logout()}>
          <Space>
            <LogoutOutlined />
            {t('accountMenu.logout')}
          </Space>
        </div>
      ),
      key: 'Logout',
    },
  ]

  return (
    <Dropdown menu={{ items }} trigger={['click']} placement={'bottomRight'}>
      <div data-testid="profile-dropdown" className="account-menu-title">
        <Icon name="accountMenu" />
      </div>
    </Dropdown>
  )
}

export default AccountMenu
